import * as Yup from "yup";
// const SUPPORTED_FORMATS = ["image/jpg", "image/jpeg", "image/png"];

const Visitor = Yup.object({
     initiatorName: Yup.string().when("SelectType", {
    is: (val) => val === "Visit",
    then: (schema) => schema.required("Initiator Name is required when Visit is selected"),
    otherwise: (schema) => schema.notRequired(),
  }),
  department: Yup.string()
    .required("Department is required")
    .notOneOf(["All Departments"], "Please select a specific department"),
    representing: Yup.string().required("Representing is Required"),
    contactNO: Yup.string().required("contactNO is Required"),
    visitingPersonname: Yup.string().required("Visiting Personname is Required"),
    // visitingDate: Yup.string()
    // .required("visiting Date is Required"),
    // .typeError("visiting Date must be a valid date"),
    visitingDate: Yup.string().required("Valid Upto is Required"),
    validUpto: Yup.string().required("Valid Upto is Required"),
    visitingTime: Yup.string().required("Visiting In Time is Required"),
    out_Time: Yup.string().required("Visiting out Time is Required"),
    noofPerson: Yup.string().required("No of PersonCome is Required"),
    purpose: Yup.string().required("Purpose is Required"),
    visitingType: Yup.string().required("Visiting Type is Required"),
    SelectType: Yup.string().required("Please select Host or Visit"),
  isSunday: Yup.boolean().test(
  "is-sunday-required",
  "Please check the Sunday checkbox if visiting date is Sunday",
  function (value) {
    const { visitingDate } = this.parent;
    if (!visitingDate) return true;
    const date = new Date(visitingDate);
    if (date.getDay() === 0) {
      return value === true;
    }
    return true;
  }
),
 location: Yup.string().when("SelectType", {
    is: (val) => val === "Host",
    then: (schema) => schema.required("Location is required when Host is selected"),
    otherwise: (schema) => schema.notRequired(),
  }),
  hostPersonToMeet: Yup.string().when("SelectType", {
    is: (val) => val === "Host",
    then: (schema) => schema.required("Host Person To Meet is required when Host is selected"),
    otherwise: (schema) => schema.notRequired(),
  }),
});

export default Visitor;